import React from 'react';

interface IAccordionDetailsProps {
  children: React.ReactNode;
}

export function AccordionDetails(props: IAccordionDetailsProps) {
  const { children } = props;
  return <>{children}</>;
}
